export const AppHeader = defineAsyncComponent(
  () => import('@/widgets/Header/ui/@platform/index.vue'),
);
